module.exports = __webpack_public_path__ + "fonts/Nunito-Regular.ed78643e.woff2";